__turbopack_context__.v({
  "businessType": "G-SElW_businessType",
  "formContainer": "G-SElW_formContainer",
  "panelContainer": "G-SElW_panelContainer",
  "panelContent": "G-SElW_panelContent",
  "policyCheckbox": "G-SElW_policyCheckbox",
  "title": "G-SElW_title",
  "titleContainer": "G-SElW_titleContainer",
});
